import { Box } from '@src/atoms/Box';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';
import React, { FC, useContext } from 'react';
import { MenuContext } from '../context';

import styles from './MenuItem.module.scss';

interface IProps extends IDefaultComponentProps {
  active?: boolean;
}

export const MenuItem: FC<IProps> = ({ className, style, children, active }) => {
  const { theme } = useContext(MenuContext);
  const classes = classnames(styles.root, className, ...getClasses(styles, { theme: active ? 'active' : theme }));

  return (
    <Box
      className={classes}
      style={style}
      paddingTop={12}
      paddingBottom={12}
      paddingLeft={{ DESKTOP: 24, MOBILE: 12 }}
      paddingRight={{ DESKTOP: 24, MOBILE: 12 }}
    >
      {children}
    </Box>
  );
};
